module.exports = __webpack_public_path__ + "static/img/home-client.f59a3e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-client.png
// module id = s08r
// module chunks = 1 5